import MoniotringAlertsPage from './monitoring-alerts-page';

export default MoniotringAlertsPage;